import { MINECRAFT_ITEMS } from '@crafty-companion/shared';

export function findMinecraftItems(query: string, limit = 8) {
  const search = query.trim().toLowerCase();
  if (!search) return MINECRAFT_ITEMS.slice(0, limit);
  const idSearch = search.replaceAll(/[\s-]+/g, '_');
  return MINECRAFT_ITEMS.filter(
    (item) =>
      item.name.toLowerCase().includes(search) ||
      item.id.slice('minecraft:'.length).includes(idSearch),
  ).slice(0, limit);
}
